import { render, staticRenderFns } from "./critical-hit-box.vue?vue&type=template&id=4e9842c2&scoped=true&"
import script from "./critical-hit-box.vue?vue&type=script&lang=js&"
export * from "./critical-hit-box.vue?vue&type=script&lang=js&"
import style0 from "./critical-hit-box.vue?vue&type=style&index=0&id=4e9842c2&lang=scss&scoped=true&"
import style1 from "./critical-hit-box.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9842c2",
  null
  
)

export default component.exports